export default "__VITE_ASSET__CJsc9iSm__"